import { awsToSimpleObject, IMedia, IPlace, IPlaceMediaItem, IPlaceReport } from "../models/Models";
import { ILocation, normalizeLocation } from "../models/ILocation";
import { LatLon as AWSLatLng, LazyPlaceReport, PlaceReport, Place } from "../../models";
import { cloneDeep } from "lodash-es";
import { ChangeSetListener } from "../DataStore/ChangeSet";
import { IDataProvider } from "./IDataProvider";

export function awsPlaceReportToSimplePlaceReport(
    report: PlaceReport | LazyPlaceReport
): IPlaceReport {
    return {
        id: report.id,
        owner: report.owner,
        rating: report.rating,
        text: report.text,
        date: report.date,
        waterTemp: report.waterTemp,
        visibility: report.visibility,
        wind: report.wind,
        swell: report.swell,
        placeReportsId: report.placeReportsId,
    } as IPlaceReport;
}

export function awsPlaceToSimplePlace(place: Place): IPlace {
    const sp = awsToSimpleObject(place, ["reports", "ratings"]) as IPlace;

    // Make sure location is normalized [-90, 90] lat and [-180, 180] lon
    if (sp.data.locationKnown) {
        sp.data.location = normalizeLocation(sp.data.location);
    }

    return sp;
}

export function simplePlaceToAwsPlace(place: IPlace) {
    const aws = cloneDeep(place);
    aws.data.location = simpleLocationToAwsLocation(place.data.location);
    return aws;
}

export function simpleLocationToAwsLocation(location: ILocation) {
    return new AWSLatLng({
        lat: location.lat,
        lon: location.lon,
    });
}

export abstract class IPlaceTable extends IDataProvider<IPlace> {
    // Reports
    public abstract getReports(placeId: string): Promise<IPlaceReport[]>;
    public abstract createReport(placeId: string, report: IPlaceReport): Promise<IPlaceReport>;
    public abstract deleteReport(id: string): Promise<void>;
    public abstract updateReport(item: IPlaceReport): Promise<IPlaceReport | undefined>;

    // Media
    public abstract getMediaItems(placeId: string): Promise<IPlaceMediaItem[]>;
    public abstract createMediaItem(
        placeId: string,
        media: IMedia,
        groupAccess: string[]
    ): Promise<IPlaceMediaItem>;
    public abstract deleteMediaItem(id: string): Promise<void>;
    public abstract updateMediaItem(item: IPlaceMediaItem): Promise<IPlaceMediaItem | undefined>;
}
